import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";

export const getUser = createAsyncThunk("auth/get-user", async () => {
  try {
    const response = await HomeService?.getLoginProfile();

    if (response?.status) {
      return response?.data;
    } else {
      toast.error(response?.massage);
    }
  } catch (error) {
    if (error?.response) {
      // Server responded with a status other than 2xx
      console.error("Server Error:", error?.response?.data);
      return {
        error: error?.response?.data?.message || "Server error occurred",
      };
    } else if (error?.request) {
      // Request made but no response received
      console.error("Network Error:", error?.request);
      return { error: "No response from server. Please check your network." };
    } else {
      // Something else happened
      console.error("Error:", error?.message);
      return { error: "Something went wrong. Please try again later." };
    }
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    user: null,
    isAuthenticated: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        console.log("redux", action.payload);
      })
      .addCase(getUser.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default authSlice.reducer;
